import classNames from 'classnames';
import _ from 'lodash';
import React, { useMemo } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import {
  parseOptionDescription,
  parseOptionsPrice,
} from '../../utils/manager/option-manager';

const GENDER = {
  MALE: 'M',
  FEMALE: 'F',
};

function optionPlaceHolder(optionGroup, position = null) {
  const { t } = useTranslation();
  const minRequiredOptions = optionGroup.required_min;
  const maxRequiredOptions = optionGroup.required_max;
  const optionsLabel = optionGroup.name?.toLowerCase();
  const optionsLabelArticle = optionGroup.article?.toLowerCase();

  let result;
  const optionArticle =
    optionsLabelArticle != null ? `${optionsLabelArticle} ` : '';

  let optionOrdinal;
  switch (optionGroup.gender) {
    case GENDER.FEMALE:
      optionOrdinal = 'ª';
      break;
    case GENDER.MALE:
      optionOrdinal = 'º';
      break;
    default:
      optionOrdinal = '';
  }

  if (maxRequiredOptions > 1 && position != null) {
    result = t('select-option.choose-many', {
      article: optionArticle,
      position,
      ordinal: optionOrdinal,
      label: optionsLabel,
    });
  } else {
    // TODO: apply grammar rule to article 'a' when first letter is vogoal in english lang
    result = t('select-option.choose-one', {
      article: optionArticle,
      label: optionsLabel,
    });
  }

  if (!_.isEmpty(result) && minRequiredOptions === 0) {
    result = result.concat(t('select-option.optional'));
  }

  return result;
}

function SelectOption({
  onChange,
  index,
  // position,
  className,
  // category,
  // item,
  baseValue,
  optionGroup,
  option,
  options,
  // disabled,
}) {
  // const storage = useStorage();
  // const { swalSelectClasses } = useSwal({ storage });

  const position = useMemo(() => index + 1, [index]);

  const parsedOptions = useMemo(() => {
    let visibleOptions = options.filter((o) => !o.blocked);

    if (_.isEmpty(visibleOptions)) {
      visibleOptions = options;
    }

    // visibleOptions?.forEach((op) => {
    //   if (op.price != null) {
    //     op.price.value -= baseValue;
    //   }
    // });

    return parseOptionsPrice(
      visibleOptions,
      // item.prices,
      // optionGroup.required_max,
      baseValue
    );
  }, [baseValue, options]);
  // }, [baseValue, options, item, optionGroup]);
  // }, [baseValue, options]);

  const handleOnChange = (event) => {
    onChange?.call(
      this,
      parsedOptions?.find((o) => o.id === event.target.value),
      index
    );
  };

  // function parseOption(pOption) {
  //   if (pOption.price != null) {
  //     console.log(pOption);
  //     const clone = _.cloneDeep(pOption);
  //     clone.price.value -= baseValue;

  //     return clone;
  //   }

  //   return pOption;
  // }

  return (
    <Form.Control
      className={classNames(className)}
      onChange={handleOnChange}
      as="select"
      size="md"
      defaultValue={option?.id}
    >
      <option value={null}>{optionPlaceHolder(optionGroup, position)}</option>

      {parsedOptions?.map((op) => (
        <option
          key={op?.id}
          value={op?.id}
          disabled={op?.blocked}
          // selected={option?.id === op?.id}
        >
          {parseOptionDescription(op)}
          {/* _xxxx_ */}
          {/* {parseOption(op)?.price?.value} */}
          {op?.blocked && ' (em falta)'}
        </option>
      ))}
    </Form.Control>
  );
}

export { SelectOption, optionPlaceHolder };
